import { QuestionBase } from './question-base.model';

export class tagInputQuestion extends QuestionBase<string> {
    controlType = 'taginput';
    datasource: any;
    visible: string;
    hint: string
    constructor(options: {} = {}) {
        super(options);
        this.datasource = options['datasource'];
        this.hint = options['hint']
        this.visible = (options['visible'] == undefined) ? true : options['visible'];
    }
}
